export default {"src":"/_next/static/media/social-linkedin.d2bce622.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};